<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
      style="vertical-align: top;" animationDuration="0ms" dynamicHeight
      (selectedTabChange)="srv.onMasterTabChange($event)">
      <mat-tab #myTabGrid label="基本資料">
        <div class="border-2 border-red-300">
          <div class="flex">
            <app-jkedit label="定時工作代號" #JOBIDCom id="JOBID" [(value)]="item.JOBID" [required]="true"
              placeholder="定時工作代號" [readonly]="isBrowse">
            </app-jkedit>
            <app-jkedit label="公司代號" #COMPANYIDCom id="COMPANYID" [(value)]="item.COMPANYID" placeholder="公司代號"
              [readonly]="isBrowse">
            </app-jkedit>
            <app-jktext label="" [value]="itemAny.DSCMB002">
            </app-jktext>

          </div>
          <div class="flex">
            <app-jkedit label="程式代號" #PROGIDCom id="PROGID" [(value)]="item.PROGID" placeholder="程式代號"
              [readonly]="isBrowse">
            </app-jkedit>
            <app-jktext label="" [value]="itemAny.PROGRAM" [width]="400">
            </app-jktext>
            <app-jkedit label="鎖定工作電腦" #COMPUTERCom id="COMPUTER" [(value)]="item.COMPUTER" placeholder="鎖定工作電腦"
              [readonly]="isBrowse">
            </app-jkedit>
          </div>
          <div class="flex">
            <app-jkedit label="使用者代號" #USERIDCom id="USERID" [(value)]="item.USERID" placeholder="使用者代號"
              [readonly]="isBrowse">
            </app-jkedit>
            <app-jktext label="" [value]="itemAny.UNAME">
            </app-jktext>
            <app-jknumberedit label="優先權" #PRIORITYCom id="PRIORITY" [(value)]="item.PRIORITY" [readonly]="isBrowse">
            </app-jknumberedit>
          </div>
          <div class="flex">
            <app-jkcombobox label="頻率類型" #SE101Com id="SE101" [(value)]="item.SE101" [items]="srv.SysSe101List"
              [readonly]="isBrowse">
            </app-jkcombobox>
            <app-jknumberedit label="重複頻率" #SE102Com id="SE102" [(value)]="item.SE102" placeholder="重複頻率"
              [readonly]="isBrowse">
            </app-jknumberedit>
            <app-jkcombobox label="工作類型" #STYLECom id="STYLE" [(value)]="item.STYLE" [items]="srv.SysStyleList"
              [readonly]="isBrowse">
            </app-jkcombobox>
            <app-jkcheckboxYN label="結案碼" #OKCom id="OK" [(valueYN)]="item.OK" [readonly]="isBrowse">
            </app-jkcheckboxYN>
            <app-jknumberedit label="每月執行日" #SE108Com id="SE108" [(value)]="item.SE108" placeholder="每月執行日"
              [readonly]="isBrowse">
            </app-jknumberedit>

          </div>
          <div class="flex">
            <app-jkdatefield label="計劃開始日期" #SE111Com id="SE111" [(value)]="item.SE111" placeholder="計劃開始日期"
              [readonly]="isBrowse">
            </app-jkdatefield>
            <app-jktext label="計劃開始時間" [value]="item.SE112">
            </app-jktext>
            <app-jkdatefield label="設定時間" #DTREQUESTCom id="DTREQUEST" [(date)]="item.DTREQUEST" placeholder="設定時間"
              [readonly]="isBrowse">
            </app-jkdatefield>
            <app-jkedit label="保留" #SE103Com id="SE103" [(value)]="item.SE103" placeholder="保留" [readonly]="isBrowse">
            </app-jkedit>

          </div>
          <div class="flex">
            <app-jkedit label="每日時分" #HHMMCom id="HHMM" [(value)]="item.HHMM" placeholder="每日時分" [readonly]="isBrowse">
            </app-jkedit>
            <app-jkdatefield label="開始日期" #SE106Com id="SE106" [(value)]="item.SE106" placeholder="開始日期"
              [readonly]="isBrowse">
            </app-jkdatefield>
            <app-jkdatefield label="結束日期" #SE107Com id="SE107" [(value)]="item.SE107" placeholder="結束日期"
              [readonly]="isBrowse">
            </app-jkdatefield>
            <app-jktext label="時間範圍-起" [value]="item.SE104">
            </app-jktext>
            <app-jktext label="時間範圍-迄" [value]="item.SE105">
            </app-jktext>

          </div>
          <div class="flex">
            <app-jkdatefield label="下次日期" #SE109Com id="SE109" [(value)]="item.SE109" placeholder="下次日期"
              [readonly]="isBrowse">
            </app-jkdatefield>
            <app-jktext label="下次時間" [value]="item.SE110">
            </app-jktext>
            <app-jkcombobox label="變動欄位" #SE100Com id="SE100" [(value)]="item.SE100" [items]="srv.se100List"
              (valueChange)="srv.se100Change()"
              [readonly]="isBrowse">
            </app-jkcombobox>
            <button (click)="srv.setSe100List(item.PARAM1)" [disabled]="isBrowse" class="btn-primary">更新條件選項</button>
            <button (click)="srv.doParamTest()" [disabled]="isBrowse" class="btn-primary">條件值測試</button>
          </div>
          <div class="flex">
            <app-jkedit label="變動欄位公式-起" #SE114Com id="SE114" [width]="300" [(value)]="item.SE114"
              placeholder="變動欄位公式-起" [readonly]="isBrowse">
            </app-jkedit>
            <app-jkedit label="變動欄位公式-迄" #SE115Com id="SE115" [width]="300" [(value)]="item.SE115"
              placeholder="變動欄位公式-迄" [readonly]="isBrowse">
            </app-jkedit>
          </div>
          <div class="flex">
            <app-jkcombobox label="MAIL通知方式" #SE116Com id="SE116" [(value)]="item.SE116" [items]="srv.SysSe116List"
              [readonly]="isBrowse">
            </app-jkcombobox>
            <app-jkedit label="MAIL帳號" #SE117Com id="SE117" [(value)]="item.SE117" placeholder="MAIL帳號" [width]="400"
              [readonly]="isBrowse">
            </app-jkedit>

          </div>
          <div class="jk-grid-cols-2">
            <app-jktextarea label="備註" #SE113Com id="SE113" [(value)]="item.SE113" placeholder="備註" [rows]="3"
              [readonly]="isBrowse">
            </app-jktextarea>
            <app-jktextarea height="250px" label="參數內容" #PARAM1Com id="PARAM1" [(value)]="item.PARAM1"
              placeholder="參數內容" [rows]="3" [readonly]="isBrowse">
            </app-jktextarea>
          </div>
          <div class="flex">
            <app-jkcheckboxYN label="週一" #WEEK1Com id="WEEK1" [(valueYN)]="item.WEEK1" [readonly]="isBrowse">
            </app-jkcheckboxYN>
            <app-jkcheckboxYN label="週二" #WEEK2Com id="WEEK2" [(valueYN)]="item.WEEK2" [readonly]="isBrowse">
            </app-jkcheckboxYN>
            <app-jkcheckboxYN label="週三" #WEEK3Com id="WEEK3" [(valueYN)]="item.WEEK3" [readonly]="isBrowse">
            </app-jkcheckboxYN>
            <app-jkcheckboxYN label="週四" #WEEK4Com id="WEEK4" [(valueYN)]="item.WEEK4" [readonly]="isBrowse">
            </app-jkcheckboxYN>
            <app-jkcheckboxYN label="週五" #WEEK5Com id="WEEK5" [(valueYN)]="item.WEEK5" [readonly]="isBrowse">
            </app-jkcheckboxYN>
            <app-jkcheckboxYN label="週六" #WEEK6Com id="WEEK6" [(valueYN)]="item.WEEK6" [readonly]="isBrowse">
            </app-jkcheckboxYN>
            <app-jkcheckboxYN label="週日" #WEEK7Com id="WEEK7" [(valueYN)]="item.WEEK7" [readonly]="isBrowse">
            </app-jkcheckboxYN>

          </div>
          <div class="flex">
            <app-jkedit label="參數內容" #PARAM1Com id="PARAM1" [(value)]="item.PARAM1" placeholder="參數內容"
              [readonly]="isBrowse">
            </app-jkedit>

          </div>

        </div>
      </mat-tab>
      <mat-tab #myTabDetail label="參數明細">
        <app-dispatcher-param [style]="item.STYLE" [(values)]="item.PARAM1" (valuesChange)="srv.valueChange($event)">
        </app-dispatcher-param>
      </mat-tab>
    </mat-tab-group>

  </div>
</div>
